import { WorksSearchStateContext } from "context/WorksSearchProvider";
import { useContext } from "react";

export const useWorksSearchState = () => {
    const context = useContext(WorksSearchStateContext);
    if (context === undefined) {
      throw new Error('useWorksSearchState must be used within a WorksSearchProvider');
    }
    return context;
  };